export default "__VITE_ASSET__Baq6aL5s__"